import axios from "axios";

const state = {
    discountCodes: [],
    discountCodeUsages: {
        items: [],
        total: 0,
        last_page: 1,
    },
};

const getters = {
    discountCodes: state => state.discountCodes,
    discountCodeUsages: state => state.discountCodeUsages,
};

const mutations = {
    setDiscountCodes: (state, discountCodes) => (state.discountCodes = discountCodes),
    setDiscountCodeUsages: (state, discountCodeUsages) => (state.discountCodeUsages = discountCodeUsages),
};

const actions = {
    async fetchDiscountCodes({commit}) {
        const {data} = await axios.get('/v2/discount-codes');

        commit('setDiscountCodes', data.data);
    },
    async deactivateDiscountCode({commit}, discountCodeId) {
        await axios.delete(`/v2/discount-codes/${discountCodeId}`);
    },
    async deleteDiscountCode({commit}, discountCodeId) {
        await axios.delete(`/v2/discount-codes/${discountCodeId}/delete`);
    },
    async activateDiscountCode({commit}, discountCodeId) {
        await axios.post(`/v2/discount-codes/${discountCodeId}/activate`);
    },
    async fetchDiscountCodeUsages({commit}, params) {
        const {data} = await axios.get('/v2/discount-codes/usages', {params});

        commit('setDiscountCodeUsages', {
            items: data.data,
            total: data.total,
            last_page: data.last_page,
        });
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
